/**
 * Neuigkeiten: rendert das Änderungsprotokoll (CHANGELOG.md, beim Build
 * eingebettet — keine API nötig). Beim Öffnen wird die neueste Version als
 * "gesehen" gemerkt, damit der Hinweispunkt in der Navigation verschwindet.
 *
 * Seit dem Leitstand-Umbau trägt jede Version eine eigene Karte. Farben
 * kommen ausschließlich aus der Token-Schicht (styles/index.css) — die
 * Seite kennt keinen einzigen festen Farbwert.
 */

import { useEffect, useMemo } from 'react';
import { useAuth } from '../../App';
import { LeitstandRahmen } from '../../components/leitstand/LeitstandRahmen';
import { Karte } from '../../components/leitstand';
import { parseChangelog, markChangelogSeen } from '../../utils/changelog';

export default function ChangelogPage() {
  const { user } = useAuth();
  const entries = useMemo(() => parseChangelog(), []);

  useEffect(() => {
    markChangelogSeen();
  }, []);

  return (
    <LeitstandRahmen titel="Neuigkeiten" benutzer={user?.displayName}>
      <div className="flex max-w-[820px] flex-col gap-5">
        <p className="text-sm text-tinte-2">Was sich mit den einzelnen Versionen geändert hat.</p>

        {entries.length === 0 ? (
          <p className="py-12 text-center text-sm text-tinte-3">Noch keine Einträge.</p>
        ) : (
          entries.map((entry) => (
            <Karte
              key={entry.version}
              titel={`Version ${entry.version}`}
              marke={entry.date || undefined}
            >
              <div className="flex flex-col gap-4">
                {entry.groups.map((group, gi) => (
                  <div key={gi} className="flex flex-col gap-1.5">
                    {group.title && (
                      <span className="font-zahl text-[10px] uppercase tracking-[0.13em] text-tinte-3">
                        {group.title}
                      </span>
                    )}
                    <ul className="list-disc space-y-1 pl-5 text-sm text-tinte-2 marker:text-tinte-3">
                      {group.items.map((item, ii) => (
                        <li key={ii}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </Karte>
          ))
        )}
      </div>
    </LeitstandRahmen>
  );
}
